var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKaercherLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 68,
    viewBox: "0 0 160 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 39.875H17.5V49.875H142.5V39.875Z",
    fill: "#FFED00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.25 23.625C66.25 25.25 65.625 25.625 64 25.625H61.75V21.75H64C65.75 21.75 66.25 22.25 66.25 23.625ZM71.875 23.5C71.875 19.75 69.25 17.875 64.25 17.875H56.625V34.875H62V29.25H64.25L67.125 34.875H73.375L69 28.25C70.75 27.5 71.875 25.625 71.875 23.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.625 30.625V28H121.625V24.375H114.625V22.125H123V17.875H109.375V34.875H123.25L123.375 30.625H114.625Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.125 34.875V17.875H100.875V24.125H95.25V17.875H89.875V34.875H95.25V28.5H100.875V34.875H106.125Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.375 18.25C86.25 17.75 84.5 17.5 82.875 17.5C76.375 17.5 73.375 20.875 73.375 26.25C73.375 32.125 76.5 35.125 82.375 35.125C84.125 35.125 86 34.75 87.5 34.125L86.875 30.25C85.75 30.625 84.5 31 83 31C79.75 31 78.875 29.875 78.875 26.375C78.875 23 79.625 21.875 82.875 21.875C84.375 21.875 85.625 22.125 86.75 22.375L87.375 18.25Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.625 23.625C135.625 25.25 135 25.625 133.375 25.625H131.125V21.75H133.375C135 21.75 135.625 22.25 135.625 23.625ZM141.125 23.5C141.125 19.75 138.5 17.875 133.5 17.875H125.875V34.875H131.25V29.25H133.5L136.375 34.875H142.625L138.25 28.25C140 27.5 141.125 25.625 141.125 23.5Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 28H42.875L44.25 23.5L44.75 21.75H44.875L45.375 23.5L46.75 28ZM54.875 34.875L48 17.875H41.875L35 34.875H40.625L41.5 32H47.875L48.75 34.875H54.875V34.875Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 17.875H35.5V21.5H39.5V17.875Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 17.875H50.375V21.5H54.375V17.875Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.625 17.875L24.5 24.25H22.875V17.875H17.5V34.875H22.875V28.25H24.5L28.625 34.875H35L29.125 25.875L34.75 17.875H28.625Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKaercherLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kaercher-logo.d0ddf7802a88efe72cfb316d895b9bc1.svg";